import aa from "./index.vue"
var o = {};
o.install = function(Vue,ops){
	Vue.component(aa.name,aa);
}
export default o 


// WEBPACK FOOTER //
// ./src/lib/index.js